import React, { createContext, useMemo, useReducer } from 'react';
import eventActions from '@/actions/site/eventActions';
import eventReducer from '@/reducers/site/eventReducer';

export const EventContext = createContext();

const EventContextProvider = (props) => {
  const [eventState, dispatch] = useReducer(eventReducer, {
    eventProgress: false,
    eventLoaded: false,
    eventError: null,
    hasTicketAccess: true,
    event: null,
  });
  const actions = useMemo(() => eventActions(dispatch), [dispatch]);

  return (
    <EventContext.Provider value={{ eventState, dispatch, actions }}>
      {props.children}
    </EventContext.Provider>
  );
};

export default EventContextProvider;
